import { defineComponent as _defineComponent } from 'vue'
import { format } from "date-fns";
import { internalDateFormat } from "@/core/constants";
import { computed, onMounted, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'BasketDeliveryTypeB2B',
  props: {
    orderDeliveryType: null,
    orderDeliveryDate: null,
    firstDeliveryDate: null,
    lastDeliveryDate: null
  },
  emits: ["type-change", "date-change"],
  setup(__props: any, { emit }: { emit: ({(e: "type-change", deliveryType: string): void,
    (e: "date-change", date: string): void}), expose: any, slots: any, attrs: any }) {

const props = __props as {
orderDeliveryType: number,
orderDeliveryDate?: string | null,
firstDeliveryDate?: Date,
lastDeliveryDate?: Date
}





onMounted(() => {
    orderDeliveryDateValidation.value = props.orderDeliveryDate;
});

const deliveryDate = computed<Date>(() => {
    if (!props.orderDeliveryDate) { return null; }

    const datetime = Date.parse(props.orderDeliveryDate);
    if (Number.isNaN(datetime)) { return null; }

    return new Date(datetime);
});

const orderDeliveryDateValidation = ref<string | undefined>(undefined);

function onDeliveryTypeChange(deliveryType: string) {
    emit("type-change", deliveryType);
}

function updateDeliveryDate(input: Date) {
    orderDeliveryDateValidation.value = null;

    if (input) {
        orderDeliveryDateValidation.value = input.toString();
        emit("date-change", format(input, internalDateFormat));
    }
}

function isDatePickerVisible() {
    return (props.orderDeliveryType === 2);
}

// animation
function beforeEnter(el) { el.style.height = "0"; el.style.overflow = "hidden"; }
function enter(el) { el.style.height = el.scrollHeight + "px"; el.style.overflow = "visible"; }
function beforeLeave(el) { el.style.height = el.scrollHeight + "px"; el.style.overflow = "hidden"; }
function leave(el) { el.style.height = "0"; el.style.overflow = "hidden"; }

return { __sfc: true,props, emit, deliveryDate, orderDeliveryDateValidation, onDeliveryTypeChange, updateDeliveryDate, isDatePickerVisible, beforeEnter, enter, beforeLeave, leave }
}

})